import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios'
import { toast } from 'react-toastify';
import { Editor } from '@tinymce/tinymce-react';

import authContext from '../../context/authContext/authContext';
import { useDispatch } from 'react-redux';
import { editProductAction } from '../../redux/actions/productsAction';
import RenderError from '../../utils/RenderError';

const IMAGE_UPLOAD_ENDPOINT = "https://api.cloudinary.com/v1_1/dnut9ipl0/image/upload"

const EditProduct = ({ isOpen, toggle, parentId, subProductId, products, getProducts, loading }) => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const intialState = { titleError: '', editProductError: '', product: {} }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const validateTitle = () => {
    if (!state.product?.title.trim()) {
      setState({ titleError: '*Please enter product title' });
    }
  }

  const validateSlogan = () => {
    if (!state.product?.slogan.trim()) {
      setState({ sloganError: '*Please enter product slogan' });
    }
  };


  const validateDescription = () => {
    if (!state.product?.description.trim()) {
      setState({ descriptionError: '*Please enter description' });
    }
  };

  const validateTokens = () => {
    const { tokens } = state.product || {};
    if (tokens === '' || tokens === null || tokens === undefined) {
      setState({ tokensError: '*Please enter valid tokens' });
    }


    if (isNaN(tokens)) {
      setState({ tokensError: '*Tokens must be a number' });
    }
  };

  const onHideModal = () => {
    setState({ ...intialState });
    toggle();
  }

  useEffect(() => {
    const id = subProductId || parentId

    let product = (products || []).find((product) => product?._id === parentId);
    if (subProductId) {
      product = (product.subProducts || []).find((product) => product?._id === subProductId);
    }

    setState({ product: JSON.parse(JSON.stringify(product || {})) })
  }, [parentId, subProductId]);


  const handleSubmit = (e) => {
    e.preventDefault();
    editProduct();
  }


  const updateProductState = (key, value) => {
    const { product } = state || {};
    product[key] = value;
    setState({ product })
  }


  const editProduct = async () => {
    const { product: { title, slogan, description, tokens }, titleError, sloganError, descriptionError, tokensError, editProductError } = state;
    const isValid = title && slogan && description && (editProductError === intialState.editProductError);
    if (!isValid) {
      setState({ editProductError: '*Please fill all the required fields' });
      return;
    }

    const config = getConfig()
    const update = { ...state.product, title, slogan, description, tokens }
    dispatch(editProductAction(update, config, getProducts, onHideModal))
  }



  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Edit Product</div>
          <div className='ml-3'>
            {loading ? <div class="spinner-border text-primary" role="status" /> : null}
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label>Title</label>
            <input
              type="text"
              class="form-control"
              value={state.product?.title}
              onChange={(e) => updateProductState('title', e.target.value)}
              onFocus={() => setState({ titleError: '', editProductError: '' })}
              onBlur={validateTitle}
              disabled={loading}
            />
            <RenderError error={state?.titleError} />
          </div>

          <div class="form-group">
            <label>Slogan</label>
            <input
              type="text"
              class="form-control"
              value={state.product?.slogan}
              onChange={(e) => updateProductState('slogan', e.target.value)}
              onFocus={() => setState({ sloganError: '', editProductError: '' })}
              onBlur={validateSlogan}
              disabled={loading}
            />
            <RenderError error={state?.sloganError} />
          </div>

          <div class="form-group">
            <label>Description</label>
            <input
              type="text"
              class="form-control"
              value={state.product?.description}
              onChange={(e) => updateProductState('description', e.target.value)}
              onFocus={() => setState({ descriptionError: '', editProductError: '' })}
              onBlur={validateDescription}
              disabled={loading}
            />
            <RenderError error={state?.descriptionError} />
          </div>

          <div class="form-group">
            <label>Tokens</label>
            <input
              type="number"
              class="form-control"
              min={0}
              value={state.product?.tokens}
              onChange={(e) => updateProductState('tokens', e.target.value)}
              onFocus={() => setState({ tokensError: '', editProductError: '' })}
              onBlur={validateTokens}
              disabled={loading}
            />
            <RenderError error={state?.tokensError} />
          </div>

          <RenderError error={state?.editProductError} />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <Button type='submit' color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={loading}>
          Update Product
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EditProduct;